module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("User Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Avatar")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Roles")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "disabled": _vm.userType != 1,
      "ripple": ""
    }
  }, [_vm._v("Branches / Departments")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "disabled": _vm.fncCheckDisable(),
      "ripple": ""
    }
  }, [_vm._v("Regions")]), _vm._v(" "), _c('v-tab', {
    key: 6,
    staticClass: "tab",
    attrs: {
      "disabled": _vm.fncCheckDisable(),
      "ripple": ""
    }
  }, [_vm._v("Limits")]), _vm._v(" "), _c('v-tab', {
    key: 7,
    staticClass: "tab",
    attrs: {
      "disabled": _vm.userType != 2,
      "ripple": ""
    }
  }, [_vm._v("Customer Store Assign")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Active for MyOrder")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.activeMyorder),
      callback: function($$v) {
        _vm.activeMyorder = $$v
      },
      expression: "activeMyorder"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Link user to me")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.linkUser),
      callback: function($$v) {
        _vm.linkUser = $$v
      },
      expression: "linkUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Send user email to confirm registration and change password")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.sendConfirmation),
      callback: function($$v) {
        _vm.sendConfirmation = $$v
      },
      expression: "sendConfirmation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* User Type:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.linkType,
      "rules": _vm.userTypeRule,
      "item-value": "id",
      "label": "User Type",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncChangeUserType
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* First Name")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "First Name",
      "rules": _vm.firstNameRule,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Surname")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Surname",
      "rules": _vm.surnameRule,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.surname),
      callback: function($$v) {
        _vm.surname = $$v
      },
      expression: "surname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Contact No")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Contact No",
      "rules": _vm.contactNoRule,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.contactNo),
      callback: function($$v) {
        _vm.contactNo = $$v
      },
      expression: "contactNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Username (Email Address)")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Email Address",
      "rules": _vm.usernameRule,
      "browser-autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.uName),
      callback: function($$v) {
        _vm.uName = $$v
      },
      expression: "uName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": "password",
      "rules": _vm.passwordRule,
      "browser-autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.uPass),
      callback: function($$v) {
        _vm.uPass = $$v
      },
      expression: "uPass"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Confirm Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Confirm Password",
      "type": "password",
      "rules": _vm.confirmPasswordRule,
      "autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Alternative Contact No")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Alternative Contact No",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.alternativeContactNo),
      callback: function($$v) {
        _vm.alternativeContactNo = $$v
      },
      expression: "alternativeContactNo"
    }
  })], 1), _vm._v(" "), (this.userType == 2) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("VAT No:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Vat No",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.vatNo),
      callback: function($$v) {
        _vm.vatNo = $$v
      },
      expression: "vatNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.userType == 2) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("External Account Code")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "External Account Code",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userReference),
      callback: function($$v) {
        _vm.userReference = $$v
      },
      expression: "userReference"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": "",
      "else": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Rep Code")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "User Rep Code",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userReference),
      callback: function($$v) {
        _vm.userReference = $$v
      },
      expression: "userReference"
    }
  })], 1), _vm._v(" "), (_vm.userAddCompanies != '' && this.userType != 1 && this.userType != 6) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Link to Company:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.userAddCompanies,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "label": "Company",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.userCompany),
      callback: function($$v) {
        _vm.userCompany = $$v
      },
      expression: "userCompany"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.userType == 6) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Link to Vendor:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.userVendors,
      "item-value": "id",
      "label": "Vendor",
      "autocomplete": "",
      "solo": "",
      "multiple": ""
    },
    model: {
      value: (_vm.userVendor),
      callback: function($$v) {
        _vm.userVendor = $$v
      },
      expression: "userVendor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.userType == 2) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Trade Customer")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.tradeCustomer),
      callback: function($$v) {
        _vm.tradeCustomer = $$v
      },
      expression: "tradeCustomer"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('p', [_vm._v("Please select a logo to upload ( Max size: 5mb )")]), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.userAvatar) + "\n                  "), (this.userAvatar == '') ? _c('p', [_c('br'), _c('strong', [_vm._v("No avatar has been uploaded")])]) : _vm._e(), _vm._v(" "), (this.userAvatar != '') ? _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "clear": "both",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncResetAvatar.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove Avatar")])]) : _vm._e(), _vm._v(" "), (this.userAvatar != '') ? _c('img', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "src": this.userAvatar,
      "width": "300"
    }
  }) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Role:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.userAddRoles,
      "item-value": "id",
      "rules": _vm.userRoleRule,
      "item-text": "name",
      "label": "Role",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.userRole),
      callback: function($$v) {
        _vm.userRole = $$v
      },
      expression: "userRole"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-left": "0px !important",
      "margin-left": "0px !important"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-left": "0px !important"
    },
    attrs: {
      "append-icon": "search",
      "label": "Filter Branches",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-tooltip', {
    staticClass: "blackTool",
    attrs: {
      "top": ""
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sagittis et neque non consectetur. Integer a tempor nisl. Suspendisse potenti. Praesent tincidunt neque sed mi dignissim, ac sodales leo convallis. Praesent volutpat metus ut massa dictum, sed rhoncus erat tincidunt. Nunc commodo massa nec ligula elementum scelerisque. Mauris fermentum odio purus, ac condimentum libero bibendum quis. Pellentesque orci enim, lobortis sit amet volutpat non, luctus sed odio. Quisque quis mi et turpis finibus lobortis. Nullam consequat vel risus vel facilisis. Cras ultrices, lacus non viverra pretium, enim nibh eleifend nunc, at tristique purus magna sit amet ligula. Quisque in malesuada turpis, et mattis odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Praesent placerat diam tellus, non consequat tellus vestibulum nec. Ut semper, ligula in eleifend scelerisque, arcu quam convallis nibh, at condimentum libero ipsum auctor elit.")]), _vm._v(" "), _c('p', [_vm._v("Suspendisse erat risus, scelerisque eget ante ac, sodales mattis sem. Donec quis metus arcu. Mauris vitae risus quis metus ultricies lacinia luctus nec velit. Integer eu faucibus lacus. Nunc arcu sem, posuere quis eros in, commodo feugiat arcu. Nam auctor ligula neque, a varius nunc interdum et. Aliquam molestie dictum diam id semper. Vestibulum id nisl vitae nisi congue fringilla quis in metus. Praesent quis orci non nunc facilisis bibendum non sit amet lacus. Vestibulum consectetur sollicitudin turpis, a aliquet eros fringilla quis. In nulla nunc, ultrices non porta in, sollicitudin quis magna. Nunc aliquam in nisl non tincidunt.")]), _vm._v(" "), _c('p', [_vm._v("Aliquam mi quam, auctor quis consequat ut, scelerisque id nibh. Fusce et ligula luctus, condimentum quam in, rutrum augue. Aenean varius posuere nibh, a iaculis est mollis in. Aenean mollis porta dolor ac eleifend. Duis justo turpis, congue ac dolor vel, rutrum suscipit augue. Nulla euismod turpis in est dignissim fringilla. Quisque volutpat gravida nunc, ac porttitor leo mollis eleifend. Sed egestas augue vitae elit vestibulum hendrerit. Donec suscipit eros ut vulputate tincidunt. Suspendisse venenatis, quam et porttitor faucibus, urna turpis ultricies est, sed molestie neque erat ullamcorper eros. Proin cursus pulvinar lacinia.")]), _vm._v(" "), _c('p', [_vm._v("Duis eu efficitur ligula. Nullam iaculis metus sit amet elit pulvinar elementum. Suspendisse condimentum nisi et augue porttitor fermentum. Phasellus ornare, dui in commodo iaculis, sem lectus efficitur tortor, sit amet convallis orci ipsum ut sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ultricies nisi non diam faucibus lobortis. Proin eget libero aliquet, rhoncus orci id, rutrum quam. Aliquam sit amet sapien venenatis, pulvinar lacus eu, convallis neque.")]), _vm._v(" "), _c('p', [_vm._v("Nulla facilisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris suscipit risus vitae tellus eleifend, quis venenatis nisi congue. Nam condimentum massa a velit dictum auctor. Vivamus dui diam, interdum in commodo id, feugiat non dolor. Duis elementum, erat sed ultrices pretium, quam tellus iaculis diam, aliquet mollis ante arcu viverra urna. Donec elementum ornare erat, non maximus nisi vestibulum a. Nam eros lorem, malesuada nec lorem ac, lacinia scelerisque nisi. Aenean nec fringilla urna. Sed congue eleifend ullamcorper. Praesent in pharetra dolor, a ornare purus.")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background": "black",
      "padding": "10px",
      "width": "100px",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Close")])])], 1), _vm._v(" "), _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 settingTable",
    attrs: {
      "headers": _vm.branchHeaders,
      "search": _vm.search,
      "items": _vm.branchesDepartments,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncChangeObject()
            }
          },
          model: {
            value: (props.item.active),
            callback: function($$v) {
              _vm.$set(props.item, "active", $$v)
            },
            expression: "props.item.active"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('v-select', {
          staticStyle: {
            "width": "90%",
            "border": "none !important"
          },
          attrs: {
            "items": _vm.departmentList,
            "label": "Select Departments",
            "item-text": "name",
            "item-value": "id",
            "autocomplete": "",
            "multiple": "",
            "solo": ""
          },
          model: {
            value: (props.item.departments),
            callback: function($$v) {
              _vm.$set(props.item, "departments", $$v)
            },
            expression: "props.item.departments"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.responsible_rep),
            callback: function($$v) {
              _vm.$set(props.item, "responsible_rep", $$v)
            },
            expression: "props.item.responsible_rep"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.service_form_rep),
            callback: function($$v) {
              _vm.$set(props.item, "service_form_rep", $$v)
            },
            expression: "props.item.service_form_rep"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          model: {
            value: (props.item.app_rep),
            callback: function($$v) {
              _vm.$set(props.item, "app_rep", $$v)
            },
            expression: "props.item.app_rep"
          }
        })], 1)])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Show me as Public user contact option in my regions")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.regionContact),
      callback: function($$v) {
        _vm.regionContact = $$v
      },
      expression: "regionContact"
    }
  })], 1), _vm._v(" "), (_vm.userRegions != '') ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.regionHeader,
      "search": _vm.search,
      "id": "hello",
      "items": _vm.userRegions,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [2000, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
            }
          },
          model: {
            value: (props.item.selected),
            callback: function($$v) {
              _vm.$set(props.item, "selected", $$v)
            },
            expression: "props.item.selected"
          }
        })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
          staticClass: "cursor",
          attrs: {
            "width": "95%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
          staticClass: "cursor",
          attrs: {
            "width": "95%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [(props.item.children != '') ? _c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1",
          attrs: {
            "headers": _vm.regionHeader,
            "search": _vm.search,
            "items": props.item.children,
            "hide-actions": "",
            "disable-initial-sort": "",
            "rows-per-page-items": [20, 40, 60, 80, 100]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [_c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "5%"
                }
              }, [_c('v-switch', {
                on: {
                  "change": function($event) {
                    return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
                  }
                },
                model: {
                  value: (props.item.selected),
                  callback: function($$v) {
                    _vm.$set(props.item, "selected", $$v)
                  },
                  expression: "props.item.selected"
                }
              })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                staticClass: "cursor levelone",
                attrs: {
                  "width": "95%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
                staticClass: "cursor levelone",
                attrs: {
                  "width": "95%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))])])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [(props.item.children != '') ? _c('v-data-table', {
                staticClass: "elevation-1 subTable2",
                attrs: {
                  "headers": _vm.regionHeader,
                  "search": _vm.search,
                  "items": props.item.children,
                  "hide-actions": "",
                  "disable-initial-sort": "",
                  "rows-per-page-items": [20, 40, 60, 80, 100]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [_c('td', {
                      staticClass: "leveltwo",
                      attrs: {
                        "width": "5%"
                      }
                    }, [_c('v-switch', {
                      on: {
                        "change": function($event) {
                          return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
                        }
                      },
                      model: {
                        value: (props.item.selected),
                        callback: function($$v) {
                          _vm.$set(props.item, "selected", $$v)
                        },
                        expression: "props.item.selected"
                      }
                    })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                      staticClass: "cursor leveltwo",
                      attrs: {
                        "width": "95%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
                      staticClass: "cursor leveltwo",
                      attrs: {
                        "width": "95%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))])])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [(props.item.children != '') ? _c('v-data-table', {
                      staticClass: "elevation-1 subTable3",
                      attrs: {
                        "headers": _vm.regionHeader,
                        "search": _vm.search,
                        "items": props.item.children,
                        "hide-actions": "",
                        "disable-initial-sort": "",
                        "rows-per-page-items": [20, 40, 60, 80, 100]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [_c('td', {
                            staticClass: "levelthree",
                            attrs: {
                              "width": "5%"
                            }
                          }, [_c('v-switch', {
                            on: {
                              "change": function($event) {
                                return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
                              }
                            },
                            model: {
                              value: (props.item.selected),
                              callback: function($$v) {
                                _vm.$set(props.item, "selected", $$v)
                              },
                              expression: "props.item.selected"
                            }
                          })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                            staticClass: "cursor levelthree",
                            attrs: {
                              "width": "95%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
                            staticClass: "cursor levelthree",
                            attrs: {
                              "width": "95%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.children && props.item.children.length != 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))])])]
                        }
                      }], null, true)
                    }) : _vm._e()]
                  }
                }], null, true)
              }) : _vm._e()]
            }
          }], null, true)
        }) : _vm._e()]
      }
    }], null, false, 1187376049)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 6,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Maximum Discount %")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "First Name",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.maxDiscount),
      callback: function($$v) {
        _vm.maxDiscount = $$v
      },
      expression: "maxDiscount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Maximum Incidental Value")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "First Name",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.maxIncidentalValue),
      callback: function($$v) {
        _vm.maxIncidentalValue = $$v
      },
      expression: "maxIncidentalValue"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quote Out Of Stock")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.quoteOutOfStock),
      callback: function($$v) {
        _vm.quoteOutOfStock = $$v
      },
      expression: "quoteOutOfStock"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("GP Manipulation")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.gpManipulation),
      callback: function($$v) {
        _vm.gpManipulation = $$v
      },
      expression: "gpManipulation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("GP Manipulation Minimum %")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "First Name",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.gpManipulationPercentage),
      callback: function($$v) {
        _vm.gpManipulationPercentage = $$v
      },
      expression: "gpManipulationPercentage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 7,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(this.userType == 2) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Assigned Stores / Pricelists")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddLinkedBranch()
      }
    }
  }, [_vm._v("Add Row")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 subTable3",
    attrs: {
      "headers": _vm.listTradeHeaders,
      "items": _vm.linkedBranches,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('v-select', {
          attrs: {
            "items": _vm.branchList,
            "item-value": "id",
            "item-text": "name",
            "label": "Branches",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.branch),
            callback: function($$v) {
              _vm.$set(props.item, "branch", $$v)
            },
            expression: "props.item.branch"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-select', {
          attrs: {
            "items": _vm.pricelistList,
            "item-value": "pl_id",
            "item-text": "pl_name",
            "label": "Pricelist",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.pricelist),
            callback: function($$v) {
              _vm.$set(props.item, "pricelist", $$v)
            },
            expression: "props.item.pricelist"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
          staticClass: "dropdown",
          attrs: {
            "label": "Account Number",
            "solo": "",
            "single-line": ""
          },
          model: {
            value: (props.item.account_number),
            callback: function($$v) {
              _vm.$set(props.item, "account_number", $$v)
            },
            expression: "props.item.account_number"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-select', {
          attrs: {
            "items": _vm.repsShortList,
            "item-value": "userid",
            "item-text": "full_name",
            "label": "Trade Rep",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.trade_rep),
            callback: function($$v) {
              _vm.$set(props.item, "trade_rep", $$v)
            },
            expression: "props.item.trade_rep"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "text-xs-right cancelButton",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(props.index)
            }
          }
        }, [_vm._v("Delete")])], 1)])]
      }
    }], null, false, 2341590581)
  })], 1) : _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer Assigned Stores / Pricelists")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddLinkedBranch()
      }
    }
  }, [_vm._v("Add Row")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 subTable3",
    attrs: {
      "headers": _vm.listHeaders,
      "items": _vm.linkedBranches,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('v-select', {
          attrs: {
            "items": _vm.branchList,
            "item-value": "id",
            "item-text": "name",
            "label": "Branches",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.branch),
            callback: function($$v) {
              _vm.$set(props.item, "branch", $$v)
            },
            expression: "props.item.branch"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-select', {
          attrs: {
            "items": _vm.pricelistList,
            "item-value": "pl_id",
            "item-text": "pl_name",
            "label": "Pricelist",
            "autocomplete": "",
            "solo": ""
          },
          model: {
            value: (props.item.pricelist),
            callback: function($$v) {
              _vm.$set(props.item, "pricelist", $$v)
            },
            expression: "props.item.pricelist"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "text-xs-right cancelButton",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(props.index)
            }
          }
        }, [_vm._v("Delete")])], 1)])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressSelected == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCreateUser()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.addressSelected == true && _vm.runAdd == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid || _vm.userVendorRule
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCreateUser()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed.")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}